// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__frqxT","selected":"styles_selected__3nXch"};